export default __webpack_public_path__ + "static/media/canadian.d2077f7a.jpg";